import React from 'react'
import { Text } from '@therms/atalaya'
import {Field, FieldAttributes, useFormikContext} from 'formik'

function FormikText(props: FieldAttributes<Parameters<typeof Text>[0]>) {
  const form = useFormikContext()

  return (
      <Field name={props.name}>
        {({ field, meta }) => (
            <Text
                {...props}
                error={(meta.touched || !!form.submitCount) && meta.error}
                valid={(meta.touched || !!form.submitCount) && meta.value && !meta.error}
                {...field}
            />
        )}
      </Field>
  )
}

export { FormikText }
